export default "__VITE_ASSET__DxvX_Yjz__"